<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card shadow-lg rounded">
        <div class="card-header text-center bg-dark text-primary">
          <h3>
            {{ 'MENU_LOGIN' | translate }}
          </h3>
        </div>
        <div class="card-body">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <!-- Email -->
            <div class="mb-3">
              <label for="email" class="form-label">{{ 'EMAIL' | translate }}</label>
              <input
                id="email"
                type="email"
                formControlName="email"
                class="form-control"
                [ngClass]="{ 'is-invalid': isSubmitted && formControls['email'].invalid }"
              />
              <div *ngIf="isSubmitted && formControls['email'].invalid" class="invalid-feedback">
                {{ 'EMAIL_REQUIRED' | translate }}
              </div>
            </div>

            <!-- Password -->
            <div class="mb-3">
              <label for="password" class="form-label">{{ 'PASSWORD' | translate }}</label>
              <div class="input-group">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  formControlName="password"
                  class="form-control"
                  id="password"
                  [ngClass]="{ 'is-invalid': isSubmitted && formControls['password'].invalid }"
                />
                <button
                  type="button"
                  class="btn btn-outline-secondary eye-slash-btn"
                  (click)="togglePasswordVisibility()"
                  tabindex="-1"
                >
                  <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </button>
              </div>
              <div
                *ngIf="isSubmitted && formControls['password'].invalid"
                class="invalid-feedback d-block"
              >
                {{ 'PASSWORD_REQUIRED' | translate }}
              </div>
            </div>

            <!-- Submit -->
            @let isLogingIn = isLogingIn$ | async;
            @let isLoading = isLoading$ | async;
            <div class="mb-3 text-center">
              <button
                type="submit"
                class="btn btn-primary text-dark w-100"
                [disabled]="isLoading || isLogingIn"
              >
                @if (isLoading || isLogingIn) {
                  <app-loading
                    class="align-content-center"
                    [height]="20"
                    theme="dark"
                  ></app-loading>
                }
                {{ 'MENU_LOGIN' | translate }}
              </button>
            </div>
          </form>
        </div>
        <div class="google-container">
          <div class="py-2" id="google-btn"></div>
        </div>
        <!-- <div class="d-flex justify-content-center pb-2">
          <button class="btn btn-outline-dark facebook-btn" (click)="loginWithFacebook()">
            <i class="bi bi-facebook facebook-icon"></i> Continue with Facebook
          </button>
        </div> -->

        <div class="card-footer text-center text-primary bg-dark">
          {{ 'LOGIN_PASSWORD_FORGET' | translate }}
          <a routerLink="/forgot-password">{{ 'LOGIN_PASSWORD_RESET' | translate }}</a>
        </div>
        <div class="card-footer text-center text-primary bg-dark">
          {{ 'LOGIN_NO_ACCOUNT' | translate }}
          <a routerLink="/register">{{ 'LOGIN_REGISTER' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
